import { render } from "./doctor-notification.vue?vue&type=template&id=15180821"
import script from "./doctor-notification.vue?vue&type=script&lang=js"
export * from "./doctor-notification.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__